var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSanteCorpsEspritIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "santeCorpsEspritIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.487,
    height: 38.487,
    viewBox: "0 0 38.487 38.487",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26321",
    "data-name": "Trac\\xE9 26321",
    d: "M36.081,4.788A11.3,11.3,0,0,0,27.688,1a11.176,11.176,0,0,0-7.445,2.857A11.176,11.176,0,0,0,12.8,1,11.3,11.3,0,0,0,4.406,4.788a13.6,13.6,0,0,0,0,18.007L19.3,39.071a1.288,1.288,0,0,0,1.9,0L36.081,22.794A13.6,13.6,0,0,0,36.081,4.788Zm-1.9,16.275L20.244,36.3,6.3,21.063A10.986,10.986,0,0,1,6.3,6.52a8.623,8.623,0,0,1,12.995,0,1.327,1.327,0,0,0,1.9,0,8.624,8.624,0,0,1,12.995,0A10.986,10.986,0,0,1,34.185,21.063Z",
    transform: "translate(-1 -1)",
    fill: "#F18A81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26322",
    "data-name": "Trac\\xE9 26322",
    d: "M28.809,14.132H25.6L22.138,9.513a1.283,1.283,0,0,0-2.175.2l-4.2,8.407-2.6-3.472a1.282,1.282,0,0,0-1.026-.513H8.283a1.283,1.283,0,0,0,0,2.566H11.49l3.464,4.618a1.284,1.284,0,0,0,1.026.513c.038,0,.077,0,.115-.005a1.286,1.286,0,0,0,1.033-.7l4.2-8.407,2.6,3.472a1.28,1.28,0,0,0,1.026.513h3.849a1.283,1.283,0,1,0,0-2.566Z",
    transform: "translate(0.697 1.263)",
    fill: "#F18A81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanteCorpsEspritIcon);
export default __webpack_public_path__ + "static/media/sante-corps-esprit-icon.6788a0ccab94604acf819f260cec52b3.svg";
export { ForwardRef as ReactComponent };